// google-maps-config.ts
import { InjectionToken } from '@angular/core';

export interface GoogleMapsConfig {
  apiKey: string;
  libraries: any;
}

export const GOOGLE_MAPS_CONFIG = new InjectionToken<GoogleMapsConfig>('GoogleMapsConfig');
